// Service for handling invite token validation and related API calls
import api from "./api";

export async function getTokenDetails(token: string) {
  // Directly call the backend service on port 3000 for token validation
  const res = await api.get(`/token/${token}`);
  return res.data;
}

export async function findMemberInvitationTokenByEmail(
  email: string
): Promise<any[]> {
  const res = await api.get(
    `/token/lookup?type=MEMBER_INVITATION&email=${encodeURIComponent(email)}`
  );
  return Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
}

export async function findMemberInvitationTokenByMobile(
  mobile: string
): Promise<any[]> {
  const res = await api.get(
    `/token/lookup?type=MEMBER_INVITATION&mobile=${encodeURIComponent(mobile)}`
  );
  return Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
}
